module.exports = __webpack_public_path__ + "static/img/3.f0bc633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/3.png
// module id = AipV
// module chunks = 1 3